/**
 * KAN-819: lead temperature of the client in the conversation header (modal
 * and chat page). Badge with a tooltip "<level>, <source>: <reason>"; nothing
 * without a level or for a closed client (outcome won / lost). The level is
 * changed in the client card (ClientLeadTemperatureSelect).
 */
import { LeadTemperatureBadge } from '@/components/leads/LeadTemperatureBadge';
import { leadTemperatureTooltip } from '@/lib/leadTemperature';
import type { Client } from '@/types/client';

type LeadTemperatureFields = Pick<
  Client,
  'lead_temperature' | 'lead_temperature_source' | 'lead_temperature_reason' | 'outcome'
>;

interface ConversationLeadTemperatureProps {
  client: Partial<LeadTemperatureFields> | undefined;
  className?: string;
}

export function ConversationLeadTemperature({ client, className }: ConversationLeadTemperatureProps) {
  if (!client || (client.outcome && client.outcome !== 'open')) return null;
  const tooltip = leadTemperatureTooltip(
    client.lead_temperature,
    client.lead_temperature_source,
    client.lead_temperature_reason
  );
  if (!tooltip) return null;
  return (
    <LeadTemperatureBadge
      level={client.lead_temperature}
      title={tooltip}
      className={className}
    />
  );
}
